const XIMENA_RECENTLY_VIEWED_KEY = 'ximena:recent-products:v1';
const XIMENA_RECENTLY_VIEWED_TTL = 30 * 24 * 60 * 60 * 1000;

function normalizeXimenaRecentHistory(history, currentId, now = Date.now()) {
  if (!Array.isArray(history)) return [];

  const seen = new Set();
  return history
    .filter((item) => {
      if (!item || typeof item !== 'object' || item.id == null || String(item.id) === String(currentId)) return false;
      if (typeof item.title !== 'string' || !item.title.trim()) return false;
      if (typeof item.url !== 'string' || !item.url.startsWith('/products/')) return false;
      if (!Number.isFinite(item.seenAt) || item.seenAt < now - XIMENA_RECENTLY_VIEWED_TTL || item.seenAt > now) return false;
      if (seen.has(String(item.id))) return false;
      seen.add(String(item.id));
      return true;
    })
    .slice(0, 8);
}

function initXimenaRecentlyViewed(root) {
  const data = root.querySelector('[data-recently-viewed-product]');
  const list = root.querySelector('[data-recently-viewed-list]');
  if (!data || !list) return;

  try {
    const current = JSON.parse(data.textContent);
    const stored = JSON.parse(localStorage.getItem(XIMENA_RECENTLY_VIEWED_KEY) || '[]');
    const previous = normalizeXimenaRecentHistory(stored, current.id).slice(0, 4);
    const next = [{ ...current, seenAt: Date.now() }, ...normalizeXimenaRecentHistory(stored, null)].slice(0, 8);
    localStorage.setItem(XIMENA_RECENTLY_VIEWED_KEY, JSON.stringify(next));

    previous.forEach((item) => {
      const card = document.createElement('li');
      const link = document.createElement('a');
      const media = document.createElement('span');
      const text = document.createElement('span');
      const title = document.createElement('strong');
      link.href = item.url;
      link.className = 'ximena-recently-viewed__card';
      media.className = 'ximena-recently-viewed__media';
      text.className = 'ximena-recently-viewed__text';
      title.textContent = item.title;

      if (typeof item.image === 'string' && item.image) {
        const imageUrl = new URL(item.image, location.origin);
        if (imageUrl.protocol === 'https:' && (imageUrl.origin === location.origin || imageUrl.pathname.startsWith('/cdn/'))) {
          const image = document.createElement('img');
          image.src = imageUrl.href;
          image.alt = typeof item.imageAlt === 'string' ? item.imageAlt : item.title;
          image.loading = 'lazy';
          image.width = 240;
          image.height = 240;
          media.append(image);
        }
      }
      if (!media.firstChild) media.append(root.querySelector('[data-recently-viewed-placeholder]').content.cloneNode(true));

      if (typeof item.vendor === 'string' && item.vendor) {
        const vendor = document.createElement('span');
        vendor.textContent = item.vendor;
        text.append(vendor);
      }
      text.append(title);
      link.append(media, text);
      card.append(link);
      list.append(card);
    });

    root.hidden = previous.length === 0;
  } catch {
    root.hidden = true;
  }
}

if (typeof document !== 'undefined') {
  document.querySelectorAll('[data-recently-viewed]').forEach(initXimenaRecentlyViewed);
}
